import React from 'react';
import { StyledNextButton, StyledAnchorButton } from './styles';

export const ButtonAppearances = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
    dark: 'dark',
};

interface ButtonProps {
    id?: string;
    appearance?: keyof typeof ButtonAppearances;
    as?: 'a' | 'button';
    href?: string;
    download?: string;
    target?: string;
    rel?: string;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    disabled?: boolean;
    children: React.ReactNode;
    onClick?: React.MouseEventHandler;
    style?: any;
    role?: string;
}
const Button = ({
    appearance = 'primary',
    as = 'button',
    href,
    type,
    className,
    children,
    disabled,
    ...other
}: ButtonProps) => {
    if (as === 'a' && href) {
        if (href.toLocaleLowerCase().startsWith('blob:')) {
            return (
                <StyledAnchorButton
                    {...other}
                    href={href}
                    color={appearance}
                    type={type}
                    disabled={disabled}
                    role="link"
                    className={className}
                    tabIndex={disabled ? -1 : 0} // Maintain keyboard navigation
                >
                    {children}
                </StyledAnchorButton>
            );
        }
        return (
            <StyledNextButton
                {...other}
                href={href}
                color={appearance}
                type={type}
                disabled={disabled}
                role="link"
                className={className}
                tabIndex={disabled ? -1 : 0} // Maintain keyboard navigation
            >
                {children}
            </StyledNextButton>
        );
    }

    return (
        <StyledNextButton
            {...other}
            color={appearance}
            type={type}
            disabled={disabled}
            as="button"
            className={className}
            tabIndex={disabled ? -1 : 0} // Maintain keyboard navigation
        >
            {children}
        </StyledNextButton>
    );
};

export default Button;
